import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useCentral} from '../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../models'
import {ShowSnackBar} from '../../../../../util/functions'
import {schemaRangeParameter} from '../../../../../util/validation'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {UpdateRangeParameterDto} from '../../../model'
import {createRangeParams, updateRangeParams} from '../../../services'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
import {transformArray} from '../../../../../util/utilitario'
const RangeParametersPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)

  const methods = useForm<UpdateRangeParameterDto>({
    resolver: yupResolver(schemaRangeParameter),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      AplicacionId: '',
      CampamentoId: '',
      Rangos: transformArray(
        ['Minimo', 'Maximo'].map((Rango) => ({
          Rango,
          ...Object.fromEntries(Array.from({length: 51}, (_, i) => [`R${i}`, 0])),
        })) as any,
      ),
    },
  })
  const {reset} = methods

  // console.log({initialRangeParamsSch})

  const onSubmit = async (data: UpdateRangeParameterDto) => {
    setLoading(true)
    try {
      if (currentTabItem.idToEdit) {
        data.Id = currentTabItem.idToEdit
        const response = await updateRangeParams(data)
        if (!response.data.error) {
          setLoading(false)
          ShowSnackBar('Se actualizó el registro correctamente')
          const obj: TabCentralModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            loadingTable: true,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          ShowSnackBar(response.data.message, 'error')
        }
      } else {
        const response = await createRangeParams(data)
        if (!response.data.error) {
          setLoading(false)
          reset()
          ShowSnackBar('Se creó con éxito')
          const obj: TabCentralModel = {
            ...currentTabItem,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-range-params',
            },
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          ShowSnackBar(response.data.message, 'error')
        }
      }
    } catch (error) {
      setLoading(false)
      ShowSnackBar('Error interno', 'error')
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={() => {}}
          loading={loading}
          textComponentBack='table-range-params'
          textComponentGo='form-range-params'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default RangeParametersPageWrapper
